(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurex-social-feed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-social-feed]').forEach((feed) => {
    const button = feed.querySelector('[data-social-load]');
    const placeholder = feed.querySelector('[data-social-placeholder]');
    const iframe = feed.querySelector('iframe[data-src]');
    if (!button || !placeholder || !iframe) return;
    button.addEventListener('click', () => {
      iframe.src = iframe.dataset.src;
      iframe.hidden = false;
      placeholder.hidden = true;
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSlider = (root, reviewsLength) => {
      const track = root.querySelector('[data-review-track]');
      if (!reviewsLength) return;
      track.querySelectorAll('.aurex-review').forEach((card, index) => {
        if (index === 0) return;
        card.setAttribute('aria-hidden', 'true');
      });
      let current = 0;
      let timer;
      const position = root.querySelector('[data-review-position]');
      const go = (next) => {
        track.children[current].setAttribute('aria-hidden', 'true');
        current = (next + reviewsLength) % reviewsLength;
        track.style.transform = `translateX(-${current * 100}%)`;
        track.children[current].removeAttribute('aria-hidden');
        position.textContent = `${current + 1} / ${reviewsLength}`;
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || reviewsLength < 2) return;
        stop();
        timer = window.setInterval(() => go(current + 1), Number(root.dataset.interval) || 6500);
      };
      root.querySelector('[data-review-prev]').addEventListener('click', () => { go(current - 1); start(); });
      root.querySelector('[data-review-next]').addEventListener('click', () => { go(current + 1); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      position.textContent = `1 / ${reviewsLength}`;
      start();
    };
    document.querySelectorAll('[data-aurex-reviews]').forEach(root => {
      initialiseSlider(root, root.querySelectorAll('.aurex-review').length);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
